










import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { HisInformationListItem } from "../../../domain/his/HisInformationListItem";
import { HisInformationItem } from "../../../domain/his";
import { StandardOption } from "../../system/selectors/mixins";
import { ModelEditableMixin } from "../../system/mixins";
import { EditingDocument } from "../../document/editor";
import { InformationKinds } from "../../../domain/his/behavior";

@Component({
  components: {
    selector: OptionDropDownSelector,
  }
})

export default class DepartmentFilter extends Mixins(ModelEditableMixin) {
  editingSource: (s: HisInformationListItem) => boolean;

  @Prop()
  options: HisInformationListItem[];

  @Prop()
  informationKind: InformationKinds;

  @Prop()
  editingDocument: EditingDocument;

  data(): any {
    return {
      departmentOptions: [new StandardOption<string>("指定なし", "")],
      department: "",
    };
  }
  departmentOptions: StandardOption<string>[];
  department: string;

  mounted() {
    this.setOptions();
  }

  get departments(): StandardOption<string>[] {
    return this.departmentOptions;
  }

  get selectedDepartment(): string {
    return this.department;
  }

  set selectedDepartment(value: string) {
    this.department = value;
    this.editingSource = this.createFilter();
  }

  createFilter(): (s: HisInformationListItem) => boolean {
    if (!this.department) { return; }
    switch (this.informationKind) {
      case InformationKinds.Disease: return s => this.contains(s.items, "DISEASE_SRYKA", this.department);
      case InformationKinds.Hospitalization: return s => this.contains(s.items, "ENTER_HOSP_MED_DEP", this.department);
      case InformationKinds.Operation: return s => this.contains(s.items, "OPE_SRYKA", this.department);
    }
  }

  contains(items: HisInformationItem[], name: string, value: string): boolean {
    return Enumerable.from(items).any(i => (i.name === name) && (i.value === value));
  }

  setOptions(): void {
    if (!this.options) { return; }
    this.departmentOptions = Enumerable.from(this.options)
      .selectMany(i => i.items)
      .where(x => x.name === "DISEASE_SRYKA" || x.name === "ENTER_HOSP_MED_DEP" || x.name === "OPE_SRYKA")
      .distinct(y => y.value)
      .select(o => new StandardOption<string>(o.value, o.value)).toArray();
    this.departmentOptions.unshift(new StandardOption<string>("指定なし", ""));
    
    // 違う情報の画面を表示した際に、選択している診療科が存在しない場合、指定なしに戻す
    this.selectedDepartment = Enumerable.from(this.departmentOptions).any(x => x.value === this.department)
      ? this.department
      : "";
  }

  get isDepartmentFilter(): boolean {
    return this.$configuration.behavior.document.editor.hisInformationSelector.departmentFilter.isEnable;
  }

  get departmentName(): string {
    return this.editingDocument && this.editingDocument.attributes && this.editingDocument.attributes.department
      ? this.editingDocument.attributes.department.name
      : "";
  }

  setDefaultDepartment(): void {
    if (this.isDepartmentFilter) {
      this.selectedDepartment = Enumerable.from(this.departmentOptions).any(x => x.value === this.departmentName)
        ? this.departmentName
        : "";
    }
  }
}
